module.exports = __webpack_public_path__ + "static/media/turn_every_stone.17c27315.webp";